import * as React from "react"

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10 10.774-3.56 3.561a.5.5 0 0 1-.373.167.56.56 0 0 1-.381-.187.54.54 0 0 1-.181-.387q0-.207.18-.388L9.227 10 5.665 6.44a.5.5 0 0 1-.167-.384.57.57 0 0 1 .188-.39q.18-.182.387-.182c.207 0 .266.06.387.181L10 9.226l3.56-3.56a.55.55 0 0 1 .384-.178q.21-.003.391.177.18.181.181.388 0 .205-.18.387L10.773 10l3.561 3.561q.173.174.177.373.005.2-.177.38a.54.54 0 0 1-.387.182.54.54 0 0 1-.387-.181L10 10.775Z"
    ></path>
  </svg>
)
